export const BENCHMARK_TAB_ORDER = [
  'D10_ULTIMATE_TRIAL',
  'D9_1HT1SR1WT_3WW_3VG',
  'D6_1SR1WT_2WW_2VG',
] as const

export function getBenchmarkTabs(availableGameSettings: readonly string[]): string[] {
  return BENCHMARK_TAB_ORDER.filter(gameSetting =>
    availableGameSettings.includes(gameSetting),
  )
}
